import { RECENTS_PAGE, RECENTS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const recentsViewRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: RECENTS_PAGE,
	path: RECENTS_PATH,
	resources: [],
	layout: 'home',
	subproduct: 'townsquare-home',
});
